import { useState } from 'react';
import styled from 'styled-components';
import { Box, ClickAwayListener } from '@mui/material';
import { ReactComponent as RepeatIcon } from '../../../../assets/icons/repeat-icon.svg';
import _ from 'lodash';

import { colors } from '../../../../theme';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { setPlan } from '../../../../store/reducers/term-planner';

const CustomCell = (props) => {
    const { data, initialField, currentField, inputName } = props;

    const termPlannerState = useAppSelector((state) => state.termPlanner);

    const dispatch = useAppDispatch();

    const [active, setActive] = useState(false);

    const handleOnChange = (event) => {
        const value = event.target.value;

        const termPlan = _.cloneDeep(termPlannerState.termPlan);

        const itemIndex = termPlan.items.findIndex((item) => item.id === data.id);

        termPlan.items[itemIndex][currentField] = value;

        dispatch(setPlan(termPlan));
    };

    return (
        <>
            {active && data.status !== 'cancelled' ? (
                <ClickAwayListener
                    onClickAway={() => {
                        setActive(false);
                    }}
                >
                    <StyledInput value={data[currentField]} name={inputName} onChange={handleOnChange} autoFocus />
                </ClickAwayListener>
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pr: '10px',
                        letterSpacing: '-0.05em',
                        m: '8px 0px',
                    }}
                    onDoubleClick={() => {
                        setActive(true);
                    }}
                >
                    <Box>{data[currentField] || data[initialField]}</Box>
                    {data[currentField] && data[initialField] !== data[currentField] && (
                            <>
                                <RepeatIcon />
                                <p className="new"> {data[initialField]} </p>
                            </>
                        )}
                </Box>
            )}
        </>
    );
};

export default CustomCell;

const StyledInput = styled.input`
    border: 1px solid ${colors.blue.main};
    margin-right: -5px;
    padding: 3px 7px;
    font-size: 12px;
    border-radius: 3px;
    width: ${(props) => props.name === 'room' && '50px'};

    &:focus {
        border: 1px solid ${colors.blue.main};
        background: ${colors.blue.light};
    }
`;
